import axios from "axios";
import router from "@/router";
import api from "@/api";

export const reportEditPlanModule = {
    namespaced: true,

    state: () => ({
        reportData: {},
        reportLoading: true,
        excelData: {},
        totalData: {},
        availableAdditionalFields: null,
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data;
        },

        setExcelData(state, data) {
            state.excelData = data;
        },
        setTotalData(state, data) {
            state.totalData = data;
        },
        setAvailableAdditionalFields(state, data) {
            state.availableAdditionalFields = data;
        },
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true;
            const isGenerate = Boolean(
                router.currentRoute.value.query["generate"],
            );
            const predictRevenue = router.currentRoute.value.query["revenue"]
            const predictOrders = router.currentRoute.value.query["orders_count"]
            const predictAvCheck = router.currentRoute.value.query["guest_average_check"]
            try {
                const response = await axios.get(
                    api +
                        "sale-plans/" +
                        router.currentRoute.value.query["shop"] +
                        "?month=" +
                        router.currentRoute.value.query["month"] +
                        (isGenerate ? "&generate=true" : "") + 
                        (predictRevenue ? `&revenue=${predictRevenue}` : '') +
                        (predictOrders ? `&orders_count=${predictOrders}` : '') +
                        (predictAvCheck ? `&guest_average_check=${predictAvCheck}` : ''),
                    {
                        headers: {
                            Authorization:
                                "Token " + localStorage.getItem("token"),
                        },
                    },
                );
                commit("setReportData", response.data.results);
                commit("setExcelData", response.data.results);
                commit("setTotalData", response.data.totals);

                response.data.additional_fields.map((item) => {
                    (item.label = item.name), (item.value = item.code);
                });

                commit(
                    "setAvailableAdditionalFields",
                    response.data.additional_fields,
                );
            } catch (err) {
                // Если есть ошибка
                alert(err);
            }

            state.reportLoading = false;
        },

        async changeData({}, data) {
            try {
                if (data.isAdditionalField) {
                    // Для дополнительных полей бэк ждет массив объектов
                    await axios.patch(
                        api +
                            "sale-plans/" +
                            router.currentRoute.value.query["shop"] +
                            "/" +
                            data.id +
                            "/",
                        {
                            additional_values: [
                                {
                                    id: data.fieldId,
                                    value: data.value,
                                },
                            ],
                        },
                        {
                            headers: {
                                Authorization:
                                    "Token " + localStorage.getItem("token"),
                            },
                        },
                    );
                } else {
                    // Обычные поля
                    await axios.patch(
                        api +
                            "sale-plans/" +
                            router.currentRoute.value.query["shop"] +
                            "/" +
                            data.id +
                            "/",
                        {
                            [data.type]: data.value,
                        },
                        {
                            headers: {
                                Authorization:
                                    "Token " + localStorage.getItem("token"),
                            },
                        },
                    );
                }
            } catch (err) {
                alert(err);
            }
        },
    },
};
